import { IsSet } from '@utilities/helpers/core.helpers'

import { API } from '@api'

export const renderForm = async ({ id, query }) => {
  if (!IsSet(id)) return null

  const data = await API.Forms.show(id, query)

  return data
}
